import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, leftJoin, nullsafe, unionKey } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";


type Entity = models.CancelacionREPModel;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
}

/**
* Valida un CancelarFacturaModel
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        IdREP: validation.required,
        MotivoCancelacion: validation.required
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
class CancelarREPModelFormNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const hasError = this.hasError(this.props);
        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);
        return (
            <div>
                {kea.autogrid(6, [
                    <Text field="MotivoCancelacion" label="Motivo" />,
                ])}
            </div>);
    }
}

export const CancelarREPModelForm = componentToRx(CancelarREPModelFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/reps/cancelacion/edit/form.tsx